document.querySelectorAll(".header__inline-menu details").forEach((item) => {
  let timeout;

  item.addEventListener("mouseenter", () => {
    clearTimeout(timeout);
    item.setAttribute("open", "");
  });

  item.addEventListener("mouseleave", () => {
    timeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 150); // 150ms delay
  });
});